import React, { useState } from 'react'
import '../../Components/Barbar/styles.css'
import axios from 'axios'
import { toast } from 'react-toastify'
import { useNavigate } from 'react-router-dom'
import { Oval } from 'react-loader-spinner'
// import Header from '../../Components/Header/page'
// import Footer from '../../Components/Footer/Footer'

const AdminLogin = () => {
    const naviagte = useNavigate()
    const [email, setEmail] = useState("")
    const [password, setPassword] = useState("")
    const [isLoader, setIsLoader] = useState(false)

    const login = () => {
        try {
            setIsLoader(true)
            const data = new FormData();
            data.append('type', 'admin')
            data.append('email', email)
            data.append('password', password)
            axios.post(`https://api.kazbarber.com/api/login`, data)
            .then((response) => {
                console.log(response, "barbar")
                if (response?.data?.status) {
                    setIsLoader(false)
                    localStorage.setItem('admintoken', response?.data?.data?.access_token)
                    localStorage.setItem('role', response?.data?.data?.role)
                    toast.success('sign In Successfully', {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    });
                    naviagte('/barbar')
                }else{
                    setIsLoader(false)
                toast.success('something went wrong', {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
                }
            }).catch((error)=>{
                setIsLoader(false)
                console.log(error)
                toast.success('something went wrong', {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
            })

        } catch (error) {
            setIsLoader(false)
            console.log(error)
            toast.success('something went wrong', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }
    }
    return (
        <>
            {/* <Header /> */}
            <section className='adminlogin'>
                <div className='wrapper'>
                    <h1 className='text-light'>Admin Sign In</h1>

                    <div className="">
                        <input type="text" className='input' placeholder="Email" onChange={(e) => setEmail(e.target.value)} />
                    </div>
                    <div className="">
                        <input type="password" className='input' placeholder="Password" onChange={(e) => setPassword(e.target.value)} />
                    </div>
                    {isLoader ?
                        <Oval
                            ariaLabel="loading-indicator"
                            height={50}
                            width={50}
                            strokeWidth={1}
                            strokeWidthSecondary={2000}
                            color="black"
                            secondaryColor="black"
                            wrapperStyle={{display:'flex', justifyContent:"center"}}
                        /> :
                        <button type="submit" className={'btn-sign'} onClick={login}>Login</button>
                    }

                </div>
            </section>
            {/* <Footer /> */}
        </>
    )
}

export default AdminLogin